export default "<div [ngClass]=\"graphDisabled ? 'graph-enable' : 'graph-disable'\">\n    <svg width=\"500\" height=\"500\" id=\"svg2\">\n    </svg>\n</div>"